import type { Person } from "@/services/api";

export const getAllNameCombinations = (person: Person) => {
  const { firstName, middleName, lastName } = person;

  const names = [firstName ?? "", middleName ?? "", lastName ?? ""];

  const result: string[] = [];

  const generateCombinations = (arr: string[], currentCombination: string) => {
    if (arr.length === 0) {
      result.push(currentCombination.trim());
      return;
    }

    for (let i = 0; i < arr.length; i++) {
      const nextArr = arr.slice(0, i).concat(arr.slice(i + 1));
      generateCombinations(nextArr, currentCombination + " " + arr[i]);
    }
  };

  generateCombinations(names, "");

  return result;
};
